module.exports = __webpack_public_path__ + "img/default3.377d0e62.png";